export default __webpack_public_path__ + "static/media/img4.520f360a.jpg";